import { render } from "./Permit.vue?vue&type=template&id=0dda581a"
import script from "./Permit.vue?vue&type=script&lang=ts"
export * from "./Permit.vue?vue&type=script&lang=ts"
script.render = render

export default script